module.exports = __webpack_public_path__ + "static/media/galeryAntihumidity13.e79ef4c2.jpg";